export const getResourceName = (list, resourceType) => {
  let item = list.find(item => item.value === resourceType)
  if(item) {
    return item.label
  } else {
    return '无'
  }
}